import classexamanswer from '../classexamanswer/ClassExamAnswer.vue'
export default {
    components: { classexamanswer },
    props: ['studyId', 'goodsId'],
    data() {
        return {
            //是否离开考试页面
            isLeave: false,
            //离开考试页面的路径
            leaveRoad: '',
            //离开考试页面的参数
            leaveParams: '',
            //考试题目
            testTitle: '',

            topicLen: 0,
            //考试之后获取的分数
            fenshu: 0,
            topicAnswer: null,
            //每次就请求数据库的分数
            score: 0,
            //提交试题的提示语
            tishi: '',
            // 跳转答案界面
            tiaozhuan: false,
            //判断题
            tfColor: [],
            tfChoice: [
                // {
                //     name: "单选题1",
                //     type: "单选题",
                //     options: ["选项1", "选项2"],
                //     value:'',
                // }, {
                //     name: "单选题1",
                //     type: "单选题",
                //     options: ["选项1", "选项2"],
                //     value:'',
                // }, {
                //     name: "单选题1",
                //     type: "单选题",
                //     options: ["选项1", "选项2"],
                //     value:'',
                // }, {
                //     name: "单选题1",
                //     type: "单选题",
                //     options: ["选项1", "选项2"],
                //     value:'',
                // }, {
                //     name: "单选题1",
                //     type: "单选题",
                //     options: ["选项1", "选项2"],
                //     value:'',
                // },
            ],
            //单选题
            singleColor: [],
            singleChoice: [
                // {
                //     name: "单选题1",
                //     type: "单选题",
                //     options: ["选fdsfs", "fff323","ffff111", "fff3544",],
                //     value:'',
                // },{
                //     name: "单选题2",
                //     type: "单选题",
                //     options: ["dddd22", "ddd11","ddd434", "ddd111",],
                //     value:'',
                // },{
                //     name: "单选题3",
                //     type: "单选题",
                //     options: ["选项1", "选项2","选项32", "选项1111111",],
                //     value:'',
                // },{
                //     name: "单选题4342323",
                //     type: "单选题",
                //     options: ["选项1", "选项2","选项3", "选项4",],
                //     value:'',
                // },
            ],
            // 多选题
            multipleColor: [],
            multipleChoice: [
                // {
                //     name: "多选题1",
                //     type: "多选题",
                //     options: ["选项1", "选项2","选项3", "选项4","选项5", "选项6"],
                //     value:[]
                // }, {
                //     name: "多选题1",
                //     type: "多选题",
                //     options: ["选项1", "选项2","选项3", "选项4","选项5", "选项6"],
                //     value:[]
                // }, {
                //     name: "多选题1",
                //     type: "多选题",
                //     options: ["选项1", "选项2","选项3", "选项4","选项5", "选项6"],
                //     value:[]
                // }, {
                //     name: "多选题1",
                //     type: "多选题",
                //     options: ["选项1", "选项2","选项3", "选项4","选项5", "选项6"],
                //     value:[]
                // },

            ],
            //填空题
            fillCOlor: [],
            fill: [
                // {
                //     name: "填空题1",
                //     type: "填空题",
                //     content: "今年$岁，性别是：$。",
                //     value:''
                // }, {
                //     name: "填空题2",
                //     type: "填空题",
                //     content: "今年$岁，性别是：$,考上的大学是$，限制是$",
                //     value:''
                // }, {
                //     name: "填空题3",
                //     type: "填空题",
                //     content: "今年$岁，性别是：$,年薪是$。",
                //     value:''
                // }, {
                //     name: "填空题4",
                //     type: "填空题",
                //     content: "今年$岁，性别是：$。",
                //     value:''
                // }, {
                //     name: "填空题5",
                //     type: "填空题",
                //     content: "今年$岁，性别是：$。",
                //     value:''
                // }

            ],
            fillInput: [
                // {
                //     content0:""
                // },{
                //     content1:''
                // },{
                //     content2:''
                // },{
                //     content3:''
                // },{
                //     content4:''
                // },
            ],
            examContent1: '',
            fenshulll1: '',
            testTitle1: '',
            categoryOrderId: '',
            // 是否通过考试
            passTheExam: false,
            // 用户考试花费时间
            examTime: 0,
            // 计时器
            timer: null,
            // 课程包id
            categoryId: '',
            // 课程包名称
            categoryName: '',
            // 开始考试时间
            startExamTime: '',
            // 结束考试时间
            endExamTime: '',
            // 是否提交答案
            flag: false,
        }
    },
    methods: {

        ttt() {
        },
        //返回课程主页
        toClassStudy: function () {
            this.$router.push({
                path: '/classstudy',
                query: {
                    id: this.goodsId
                }
            });
        },
        //获取数据库考试分数
        getScore: function (goodsId) {
            let me = this;
            this.$post('orders/search', { token: this.$store.state.id, offset: 0, length: '9999' }).then(res => {
                return res.data.result.data;
            }).then(data => {
                for (let val of data) {
                    (function (val) {
                        if (val.state == 2) {
                            me.$post('purchased/search', { token: me.$store.state.id, order_id: val.id, offset: 0, length: '10' }).then(res => {

                                for (let v of res.data.result.data) {
                                    if (v.product_id == goodsId) {
                                        me.score = v.score;
                                    }
                                }
                            })
                        }
                    })(val)
                }
            })
        },
        //提交答案
        goClassstudy: function () {
            let flag = true;
            // 判断判断题是否填写完整
            this.tfColor = [];
            this.singleColor = [];
            this.multipleColor = [];
            for (let i1 in this.tfChoice) {
                if (this.tfChoice[i1].value == '') {
                    this.tfColor[i1] = true;
                    flag ? flag = false : flag;
                } else {
                    this.tfColor[i1] = false;
                }
            }
            // 判断选择题是否完整
            for (let i2 in this.singleChoice) {
                if (this.singleChoice[i2].value == '') {
                    this.singleColor[i2] = true;
                    flag ? flag = false : flag;
                } else {
                    this.singleColor[i2] = false;
                }
            }
            // 判断多选题是否填写完整
            for (let i3 in this.multipleChoice) {
                if (this.multipleChoice[i3].value == '' || this.multipleChoice[i3].value.length < 2) {
                    this.multipleColor[i3] = true;
                    flag ? flag = false : flag;
                } else {
                    this.multipleColor[i3] = false;
                }
            }
            this.flag = flag;
            if (!flag) {
                UIkit.modal(document.querySelector('#modal-tishi-fill')).show();
                return;
            }
            // for (let i4 in this.fill) {
            //     if (this.fill[i4].value=='') {
            //         this.can_submit.splice(this.can_submit.indexOf('4'),1)
            //         break
            //     }
            // }
            // if (this.can_submit.length == 4){
            //     alert("格式填写正确，提交成功")

            // }else if(!this.can_submit.includes('3')){
            //     alert("多选题必须选择两个或两个以上，请重新填写")
            //     this.can_submit = ['1','2','3','4']
            //     return false
            // }
            // else{
            //     alert("格式填写错误，每个空都要选择，请重新填写")
            //     this.can_submit = ['1','2','3','4']
            //     return false
            // }

            let me = this;
            //提交答案数组里面装着选择，单选，多选，判断4个数组
            let arr = [this.tfChoice, this.singleChoice, this.multipleChoice, this.fill];
            //最终要提交给后端的数组
            let privateJSON = [];
            //提交给后端对应试题的id
            let testId = '';

            // 如果填空题数据不为空，则把执行填空题的获取我们写的答案方法
            if (me.fill.length !== 0) {
                me.fillCommit()
            }
            // 循环arr，即提交我们写的试题和答案，把里面每一项push进privateJson，即最终提交给后台的数组
            for (let item of arr) {
                if (arr.length !== 0) {
                    for (let val of item) {
                        privateJSON.push(val);
                    }
                }
            }
            let fenVal = Math.round(100 / privateJSON.length);
            // 计算提交的分数
            for (let vall of me.topicAnswer) {
                inner:
                for (let itemm of privateJSON) {
                    if (vall.name == itemm.name) {
                        if (vall.type == '多选') {
                            // console.log('=======');
                            // console.log(vall.answer);
                            for (let v of vall.answer) {
                                if (itemm.value.indexOf(v) == -1) {
                                    break inner;
                                }
                            }
                            me.fenshu += Number.parseFloat(fenVal);
                        } else {
                            vall.answer[0] == itemm.value ? me.fenshu += Number.parseFloat(fenVal) : me.fenshu;
                            break;
                        }
                    }
                }
            }
            // 给弹框提示
            me.tishi = '提交成功,请查看正确答案，如想重新答题，请返回课程主页，点击课后习题重新答题';
            UIkit.modal(document.querySelector('#modal-tishi')).show();
            //判断是否考过试，如果考过并且及格，这次分数不及格，还是取上次分数
            let lastScore = me.fenshu;
            me.$emit('ClasseXam', lastScore);//向父组件传值
            if (lastScore >= 60) {//考试通过
                me.passTheExam = true;
                me.$emit('ClasseXam', lastScore);//向父组件传值
            }
            if (Number.parseFloat(me.score) >= 60) {
                me.fenshu = Math.max(Number.parseFloat(me.fenshu), Number.parseFloat(me.score));
            }
            // 提交答案
            // me.$post('category_order/update', {
            //     token: me.$store.state.id,
            //     id: me.categoryOrderId,
            //     private: JSON.stringify(privateJSON),
            //     score: me.fenshu
            // }).then(() => {
            //     me.tiaozhuan = true
            //     me.examContent1 = JSON.stringify(privateJSON)
            //     me.fenshulll1 = lastScore
            //     me.testTitle1 = me.testTitle
            // })

            // 获取结束考试时间
            this.endExamTime = this.getNetworkTime()
            // 保存考试情况
            this.saveExamResult(JSON.stringify(privateJSON), lastScore);

            //搜索我的所有订单
            // this.$post('orders/search', { token: this.$store.state.id, offset: 0, length: '9999' }).then(res => {
            //     let idArr = [];
            //     if (res.data.result.data.length !== 0) {
            //         for (let val of res.data.result.data) {
            //             if (Number.parseInt(val.state) === 2) {
            //                 // 把订单id添加到数组里面
            //                 idArr.push(val.id);
            //             }
            //         }
            //     }
            //     // 把数组返回到下一级去查询订单的商品
            //     return idArr;
            // }).then(data => {
            //     for (let id of data) {
            //         (function () {
            //             //循环每个订单里面的每个商品和试题的商品id对比
            //             me.$post('purchased/search', { token: me.$store.state.id, order_id: id, offset: 0, length: '999' }).then(res => {
            //                 for (let v of res.data.result.data) {
            //                     if (Number.parseInt(v.product_id) === Number.parseInt(me.goodsId)) {
            //                         testId = v.id;
            //                         //对比完找到考试id返回给下一级
            //                         return testId;
            //                     }
            //                 }
            //             }).then((id) => {
            //                 // 如果填空题数据不为空，则把执行填空题的获取我们写的答案方法
            //                 if (me.fill.length !== 0) {
            //                     me.fillCommit()
            //                 }
            //                 // 循环arr，即提交我们写的试题和答案，把里面每一项push进privateJson，即最终提交给后台的数组
            //                 for (let item of arr) {
            //                     if (arr.length !== 0) {
            //                         for (let val of item) {
            //                             privateJSON.push(val);
            //                         }
            //                     }
            //                 }
            //                 let fenVal = Math.round(100 / privateJSON.length);
            //                 // 计算提交的分数
            //                 for (let vall of me.topicAnswer) {
            //                     inner:
            //                     for (let itemm of privateJSON) {
            //                         if (vall.name == itemm.name) {
            //                             if (vall.type == '多选') {
            //                                 // console.log('=======');
            //                                 // console.log(vall.answer);
            //                                 for (let v of vall.answer) {
            //                                     if (itemm.value.indexOf(v) == -1) {
            //                                         break inner;
            //                                     }
            //                                 }
            //                                 me.fenshu += Number.parseFloat(fenVal);
            //                             } else {
            //                                 vall.answer[0] == itemm.value ? me.fenshu += Number.parseFloat(fenVal) : me.fenshu;
            //                                 break;
            //                             }
            //                         }
            //                     }
            //                 }
            //                 // 给弹框提示
            //                 me.tishi = '提交成功,请查看正确答案，如想重新答题，请返回课程主页，点击课后习题重新答题';
            //                 UIkit.modal(document.querySelector('#modal-tishi')).show();
            //                 //判断是否考过试，如果考过并且及格，这次分数不及格，还是取上次分数
            //                 let lastScore = me.fenshu;
            //                 me.$emit('ClasseXam', lastScore);//向父组件传值
            //                 if (lastScore >= 60) {//考试通过
            //                     me.$emit('ClasseXam', lastScore);//向父组件传值
            //                 }
            //                 if (Number.parseFloat(me.score) >= 60) {
            //                     me.fenshu = Math.max(Number.parseFloat(me.fenshu), Number.parseFloat(me.score));
            //                 }
            //                 // 提交答案
            //                 me.$post('orders/update_answer', {
            //                     token: me.$store.state.id,
            //                     id: me.orderId,
            //                     private: JSON.stringify(privateJSON),
            //                     score: me.fenshu
            //                 }).then(() => {
            //                     me.tiaozhuan = true
            //                     me.examContent1 = JSON.stringify(privateJSON)
            //                     me.fenshulll1 = lastScore
            //                     me.testTitle1 = me.testTitle
            //                 })

            //                 // if (String(id) !== 'undefined') {
            //                 //     //如果填空题数据不为空，则把执行填空题的获取我们写的答案方法
            //                 //     if (me.fill.length !== 0) {
            //                 //         me.fillCommit()
            //                 //     }
            //                 //     //循环arr，即提交我们写的试题和答案，把里面每一项push进privateJson，即最终提交给后台的数组
            //                 //     for (let item of arr) {
            //                 //         if (arr.length !== 0) {
            //                 //             for (let val of item) {
            //                 //                 privateJSON.push(val);
            //                 //             }
            //                 //         }
            //                 //     }
            //                 //     let fenVal = Math.round(100 / privateJSON.length);
            //                 //     //计算提交的分数
            //                 //     for (let vall of me.topicAnswer) {
            //                 //         inner:
            //                 //         for (let itemm of privateJSON) {
            //                 //             if (vall.name == itemm.name) {
            //                 //                 if (vall.type == '多选') {
            //                 //                     // console.log('=======');
            //                 //                     // console.log(vall.answer);
            //                 //                     for (let v of vall.answer) {
            //                 //                         if (itemm.value.indexOf(v) == -1) {
            //                 //                             break inner;
            //                 //                         }
            //                 //                     }
            //                 //                     me.fenshu += Number.parseFloat(fenVal);
            //                 //                 } else {
            //                 //                     vall.answer[0] == itemm.value ? me.fenshu += Number.parseFloat(fenVal) : me.fenshu;
            //                 //                     break;
            //                 //                 }
            //                 //             }
            //                 //         }
            //                 //     }
            //                 //     //给弹框提示
            //                 //     me.tishi = '提交成功,请查看正确答案，如想重新答题，请返回课程主页，点击课后习题重新答题';
            //                 //     UIkit.modal(document.querySelector('#modal-tishi')).show();
            //                 //     //判断是否考过试，如果考过并且及格，这次分数不及格，还是取上次分数
            //                 //     let lastScore = me.fenshu;
            //                 //     me.$emit('ClasseXam', lastScore);//向父组件传值
            //                 //     if (lastScore >= 60) {//考试通过
            //                 //         me.$emit('ClasseXam', lastScore);//向父组件传值
            //                 //     }
            //                 //     if (Number.parseFloat(me.score) >= 60) {
            //                 //         me.fenshu = Math.max(Number.parseFloat(me.fenshu), Number.parseFloat(me.score));
            //                 //     }
            //                 //     //把我们写的答案提交给后台
            //                 //     // me.$post('purchased/sumbitResult', { id: id, private: JSON.stringify(privateJSON), token: me.$store.state.id, score: me.fenshu }).then(res => {
            //                 //     //     me.tiaozhuan = true
            //                 //     //     me.examContent1 = JSON.stringify(privateJSON)
            //                 //     //     me.fenshulll1 = lastScore
            //                 //     //     me.testTitle1 = me.testTitle
            //                 //     //     // me.$router.push({
            //                 //     //     //     //跳转到考试答案页面
            //                 //     //     //     path: '/classexamanswer',
            //                 //     //     //     query: {
            //                 //     //     //         examContent: JSON.stringify(privateJSON),
            //                 //     //     //         fenshulll: lastScore,
            //                 //     //     //         goodsId: me.goodsId,
            //                 //     //     //         testTitle: me.testTitle
            //                 //     //     //     }
            //                 //     //     // })
            //                 //     // })

            //             })
            //         })(id)
            //     }

            // })

        },
        //搞定填空题目的展示
        fillTopic: function () {
            for (let i = 0; i < this.fill.length; i++) {
                let str = this.fill[i].content;
                let index = 0;
                while (str.indexOf('$') !== -1) {
                    str = str.replace("$", `<input type='text' id='fill${i}${index}'>`);
                    index++;
                }
                this.fillInput[i]['content' + i] = str;
            }
        },
        //获取填空题目答案
        fillCommit: function () {
            for (let i = 0; i < this.fill.length; i++) {
                let str = this.fill[i].content;
                let index = 0;
                while (str.indexOf('$') !== -1) {
                    let id = '#fill' + i + index;
                    str = str.replace("$", document.querySelector([id]).value);
                    index++;
                }
                this.fill[i].value = str;
            }
        },

        //获取考试数据
        getTestData: function () {
            // let id = this.studyId;

            this.goodsId = this.$route.query.goodsId;
            // console.log('我是否拿到id了',this.$route.query.id)
            this.$post('resources/get', { id: this.$route.query.id, token: this.$store.state.id }).then(res => {
                this.testTitle = res.data.result.name;
                document.title = '课后习题:' + res.data.result.name;
                let topicArr = JSON.parse(res.data.result.data);
                this.topicLen = topicArr.length;
                this.topicAnswer = topicArr;
                for (let val of topicArr) {
                    // delete val.answer;
                    if (val.type === '判断' || val.options.length === 2) {
                    // if (val.type === '判断') {
                        val.value = '';
                        this.tfChoice.push(val);
                    // } else if (val.type === '单选' && val.options.length === 4) {
                    } else if (val.type === '单选') {
                        val.value = '';
                        this.singleChoice.push(val);
                    } else if (val.type === '多选') {
                        val.value = [];
                        this.multipleChoice.push(val);
                    } else if (val.type === '填空') {
                        val.value = '';
                        this.fill.push(val);
                    }
                }
            });
        },

        // 确认离开页面
        confirmLeave() {
            UIkit.modal(document.querySelector('#modal-leave-tips')).hide();
            let road = this.leaveRoad;
            let params = this.leaveParams;
            console.log('road', road);
            console.log('params', params);
            this.isLeave = true;
            this.$router.push({
                path: road
            });
            // this.$router.push({
            //     path: road,
            //     query: params
            // });
        },

        // 考试花费时间
        examsTakeTime() {
            this.timer = setInterval(() => {
                this.examTime++;
            }, 1000);
        },

        // 保存考试情况
        saveExamResult(JSON, lastScore) {
            // 关闭定时器
            if (this.timer !== null) {
                clearInterval(this.timer);
                this.timer = null;
            }

            // 保存
            this.$post('exam/addExamResult', {
                token: this.$store.state.id,
                category_id: this.categoryId,
                category_name: this.categoryName,
                category_order_id: this.categoryOrderId,
                score: this.fenshu,
                private: JSON,
                is_pass: this.passTheExam ? '是' : '否',
                exam_time: Math.ceil(this.examTime * 1 / 60),
                start_exam_time: this.startExamTime,
                end_exam_time: this.endExamTime,
            }).then(() => {
                this.tiaozhuan = true;
                this.examContent1 = JSON;
                this.fenshulll1 = lastScore;
                this.testTitle1 = this.testTitle;
            });
        },

         // 获取网络时间
         getNetworkTime() {
            let xmlhttp;
            if (window.XMLHttpRequest) {
                // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
                xmlhttp = new XMLHttpRequest();
            } else {
                // IE6, IE5 浏览器执行代码
                xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
            }

            xmlhttp.open("GET", "https://quan.suning.com/getSysTime.do", false);
            xmlhttp.send();

            if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                return (JSON.parse(xmlhttp.responseText).sysTime2).substring(0, 10);
            } else {
                return '';
            }

        },

    },
    beforeRouteLeave: function (to, from, next) {
        this.leaveRoad = to.path;
        this.leaveParams = to.query;
        // 考试后离开页面，不需要任何提示
        if (this.flag) {
            next();
            return;
        }
        if (to.path === '/classexamanswer') {
            UIkit.modal(document.querySelector('#modal-leave-tips')).hide();
            next();
        } else {
            if (!this.isLeave) {
                document.querySelector('#modal-leave-tips') ? UIkit.modal(document.querySelector('#modal-leave-tips')).show() : next();
            } else {
                UIkit.modal(document.querySelector('#modal-leave-tips')).hide();
                next();
            }
        }
    },
    created: function () {
        this.getTestData();
        this.getScore(this.goodsId);

        this.categoryOrderId = this.$route.query.categoryOrderId;
        this.categoryId = this.$route.query.categoryId;
        this.categoryName = this.$route.query.categoryName;

        // 获取开始考试时间
        this.startExamTime = this.getNetworkTime();
    },
    mounted: function () {
        this.fillTopic();

        // 开始计算用户考试花费时间
        this.examsTakeTime();
    },
}